import { Injectable, signal } from "@angular/core";
import { CorpTranslateService } from "@corporate-tailwind/translation";
import { OrderWizardDto } from "../../model/order-wizard.model";
import { OrderWizardSelectionDto } from "../../model/order-wizard.selection.model";
import { OrderWizardApi } from "../_service/order-wizard.api";

@Injectable({ providedIn: 'root' })
export class OrderWizardSelectionState {
    private readonly _selection = signal<OrderWizardSelectionDto | null>(null);
    private readonly _loading = signal<boolean>(true);
    private readonly _loadingCurrency = signal<boolean>(false);

    readonly selection = this._selection.asReadonly();
    readonly loading = this._loading.asReadonly();
    readonly loadingCurrency= this._loadingCurrency.asReadonly();

  constructor(    
    private _orderWizardApi: OrderWizardApi,
    private _corpTranslateService: CorpTranslateService
) {
    this._corpTranslateService.attach(this._selection);
}

  load(orderWizardDto: OrderWizardDto) {
    this._loading.set(true);

    this._orderWizardApi.getSelection(orderWizardDto).subscribe({
      next: selection => {
        selection = this._corpTranslateService.translate(selection);

        this._selection.set(selection);
        this._loading.set(false);
      },
      error: err => {
        console.error('Erreur lors du chargement utilisateur', err);
        this._loading.set(false);
      }
    });
  }


  
}